var map = {
	"./icon_Areca.svg": 1735,
	"./icon_Barringtoniaasiatica.svg": 5226,
	"./icon_Chinaberry.svg": 7404,
	"./icon_Erythrina.svg": 2415,
	"./icon_Ficus.svg": 5075,
	"./icon_Imperata.svg": 5866,
	"./icon_LargeLeavedNanmu.svg": 8100,
	"./icon_Mango.svg": 9043,
	"./icon_PaperMulberry.svg": 1049,
	"./icon_Parasolleaftree.svg": 7397,
	"./icon_Soapberry.svg": 4374,
	"./icon_SpinyBamboo.svg": 8872,
	"./icon_TaiwanFlamegold.svg": 9658,
	"./icon_Taiwancrapemyrtle.svg": 7505,
	"./icon_VitexNigra.svg": 7220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9533;